interface EnvConfig {
  API_BASE_URL?: string;
}

export const getEnv = (): EnvConfig => {
  const runtimeVal = window._env_?.API_BASE_URL;  // comes from public/config.js

  // if runtimeVal is "API_BASE_URL", docker-entrypoint.sh hasn't replaced the value
  const isPlaceholder =
    runtimeVal === undefined ||
    runtimeVal === null ||
    runtimeVal === "" ||
    runtimeVal === "$API_BASE_URL";

  return {
    API_BASE_URL:
      (!isPlaceholder && runtimeVal) ||       // replaced by env in docker-entrypoint.sh
      process.env.REACT_APP_API_BASE_URL ||   // env read during `npm start``
      "http://localhost:31337",               // fallback
  };
};
